import { Button, Col, Form, Input, notification, Radio, Row, Select } from "antd"
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { addAssignHerbApi, editClientApi, listOfDietTimeApi, listOfHerbManagementApi, listOfIngredientUnitApi, listOfMealTimeApi } from "../../../../../../config/Api";
import { API_ERR_MESSAGE, PHONE_PATTERN } from "../../../../../../config/constant";
import { FilterApiData } from "../../../../../../services/FilterApiData";

export const AddHerb = (props) => {
    const [form] = Form.useForm();
    const { Option } = Select;
    const { id } = useParams()

    const herbsOptions = [

        {
            id: 1,
            name: "Ajwain",
            kapha: true,
            vata: true,
            pitta: false,
            quantity: 4,
            // unit: 'MiliGrams',
            unit_id: "1",
            unit: {
                id: '1',
                name: "MiliGrams"
            },
            remark: "reamark of ajwain",
            mealtime: 'BreakFast'
        },
        {
            id: 'Aloe Vera', name: "Aloe Vera", kapha: false,
            vata: false,
            pitta: true,
            quantity: 4,
            unit: 'MiliGrams',
            unit_id: "1",
            unit: {
                id: '1',
                name: "MiliGrams"
            },
            remark: "reamark of ajwain",
            mealtime: 'Mid Morning'
        },
        {
            id: 'Caster Oil', name: "Caster Oil", kapha: true,
            vata: true,
            pitta: false,
            quantity: 4,
            unit: 'Liters',
            unit_id: "3",
            unit: {
                id: '3',
                name: "Liters"
            },
            remark: "reamark of Caster Oil",
            mealtime: 'BreakFast'
        },
        {
            id: 'Cardamom', name: "Cardamom", kapha: false,
            vata: true,
            pitta: false,
            quantity: 4,
            // unit: 'TeaSpoon',
            unit_id: 5,
            unit: {
                id: 5,
                name: "TeaSpoon"
            },
            remark: "reamark of ajwain",
            mealtime: 'After Lunch'
        },
        {
            id: 'Cinnamon', name: "Cinnamon", kapha: true,
            vata: false,
            pitta: true,
            quantity: 4,
            // unit: 'MiliGrams',
            mealtime: 'BreakFast',
            unit_id: 4,
            unit: {
                id: 4,
                name: "MiliGrams"
            },
            remark: "reamark of ajwain"
        },
        {
            id: 'Coconut Oil', name: "Coconut Oil", kapha: false,
            vata: false,
            pitta: true,
            quantity: 4,
            unit: 'TeaSpoon',
            mealtime: 'Mid Morning',
            unit_id: 5,
            unit: {
                id: 5,
                name: "TeaSpoon"
            },
            remark: "reamark of ajwain",
        },
        {
            id: 'Date Milk', name: "Date Milk", kapha: false,
            vata: true,
            pitta: true,
            quantity: 4,
            mealtime: 'After Lunch',
            unit: 'MiliGrams',
            unit_id: 1,
            unit: {
                id: 1,
                name: "TeaSpoon"
            },
            remark: "reamark of ajwain",
        },
        {
            id: 'Jeera Water', name: "Jeera Water", kapha: true,
            vata: true,
            pitta: false,
            quantity: 4,
            unit: 'Bowl',
            unit_id: 6,
            unit: {
                id: 6,
                name: "Bowl"
            },
            remark: "reamark of ajwain",
            mealtime: 'BreakFast'
        },
    ];
    const mealTimesOptions = [
        { id: '1', name: "Early Morning" },
        { id: '2', name: "BreakFast" },
        { id: '3', name: "After BreakFast" },
        { id: '4', name: "Mid Morning" },
        { id: '5', name: "Before Lunch" },
        { id: '6', name: "Lunch" },
        { id: '7', name: "After Lunch" },
        { id: '8', name: "Evening" },
        { id: '9', name: "Before Dinner" },
        { id: '10', name: "Dinner" },
        { id: '11', name: "After Dinner" },
        { id: '12', name: "BedTime" },
        { id: '13', name: "Before BreakFast" },
    ];
    const unitOptions = [
        { id: '1', name: "Capsule" },
        { id: '2', name: "Tablet" },
        { id: '3', name: "Miligrams" },
        { id: '4', name: "Teaspoon" },
        { id: '5', name: "Number" },
        { id: '6', name: "Liters" },
        { id: '7', name: "Kg" },
        { id: '8', name: "Bowl" },
    ];

    let userPhenoType = "vata";
    const [patientData, setPatientData] = useState({})
    const [herbsOptionsList, setHerbsOptionsList] = useState([])
    const [herbsDisplayOptionsList, setHerbsDisplayOptionsList] = useState(herbsOptionsList)

    const [defaultValueOfHerb, setDefaultValueOfHerb] = useState("")
    const [herbsCategory, setHerbsCategory] = useState("all_herbs")
    const [herb, setHerb] = useState()
    const [placeholderData, setPlaceholderData] = useState('Select Herbs')

    const [nutritionistType, setNutritionistType] = useState('');
    const [mealTimeOptions, setMealTimeOptions] = useState([]);
    const [ingredientUnitOptions, setIngredientUnitOptions] = useState([]);


    // get the list of all available herbs options and its data
    const getListOfHerbsManagement = () => {
        listOfHerbManagementApi()
            .then((res) => {
                if (res.status === 200) {
                    setHerbsDisplayOptionsList(res.data.data);
                    setHerbsOptionsList(res.data.data);
                }
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                });
            });
    }

    // get pheno type from patient detail
    const getDetailsOfPatient = async () => {
        await editClientApi(id)
            .then((res) => {
                if (res.status === 200) {
                    setPatientData(res.data.data);
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    }

    useEffect(() => {
        let NutritionistType = JSON.parse(localStorage.getItem('user'))
        // console.log("NutritionistType", NutritionistType);
        // setNutritionistType(NutritionistType?.type_of_account)
        setNutritionistType(NutritionistType?.user?.type_of_account)
        getListOfHerbsManagement()
        // get list pf mealtime options
        getListOfMealTimes()
        getDetailsOfPatient()
        getlistOfIngredientUnit()
    }, []);


    useEffect(() => {
        // console.log("called ue");
        if (herbsCategory == "recommended_herbs") {
            setPlaceholderData("Select Recommended Herbs")
            // for recommanded options we use user pheno type and filter herbOptions data 
            // if user phenoType is Kapha then from herbsOptions only options list appear that has Kapha = true  
            if (herbsDisplayOptionsList.length > 0) {
                // let filteredData = herbsOptionsList.filter((element) => element[userPhenoType] == true)
                let phenotypeData = ''
                let filteredData = []
                if (patientData) {
                    phenotypeData = patientData?.phenotype ? patientData?.phenotype?.toLowerCase() : ' '
                    // console.log("herbsOptionsList", herbsOptionsList);
                    filteredData = herbsOptionsList.filter((element) => element[phenotypeData] == true)
                }
                // console.log('filteredData', filteredData);
                if (filteredData.length > 0) {
                    setHerbsDisplayOptionsList(filteredData)

                    // now check that user that data exist in form is avaiable in recommanded select option if not then clear form
                    let herbId = form.getFieldValue('herb_name')
                    // console.log(herbId)
                    let OptionExistInRecommandData = filteredData.find((element => element.id == herbId))
                    if (!OptionExistInRecommandData) {
                        form.resetFields()
                        setHerb('')
                        setDefaultValueOfHerb('')
                    }
                } else {
                    form.resetFields()
                    setHerb('')
                    setHerbsDisplayOptionsList([])
                }
            }
        } else {
            setHerbsDisplayOptionsList(herbsOptionsList)
            setPlaceholderData("Select Herbs")
            // setHerbsOptionsList(herbsDisplayOptionsList)
            // setHerbsDisplayOptionsList(herbsOptionsList)
        }
        // console.log('filteredData');
    }, [herbsCategory])

    useEffect(() => {
        // fil the other fields data by comparing id
        if (herb) {
            // console.log(herb)
            const selectedHerbData = herbsOptionsList.find((element) => { return element.id == herb })
            // console.log("selectedHerbData", selectedHerbData)
            form.setFieldsValue({
                herb_name: selectedHerbData?.herb,
                quantity: selectedHerbData?.quantity,
                unit: selectedHerbData?.unit_id,
                remark: selectedHerbData?.remark,
                mealtime: selectedHerbData?.mealtime
            })
        }
    }, [herb])



    // get the list of alll available plans 
    const getListOfMealTimes = () => {
        listOfMealTimeApi()
            .then((res) => {
                if (res.status === 200) {
                    setMealTimeOptions(FilterApiData(res.data.data));
                }
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                });
            });
    }

    // get the list of all ingredient units
    const getlistOfIngredientUnit = () => {
        listOfIngredientUnitApi()
            .then((res) => {
                if (res.status === 200) {
                    setIngredientUnitOptions(FilterApiData(res.data.data));
                }
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                });
            });
    }

    const onFinish = (values) => {
        // console.log(values);
        const data = {
            "herb": values.herb_name,
            "quantity": values.quantity,
            "patient_id": id,
            "unit_id": values.unit,
            "meal_time_id": values.mealtime,
            "remark": values.remark,
            "status": true
        }
        addAssignHerbApi(data)
            .then((res) => {
                if (res.status == 200) {
                    notification.success({
                        message: "Assigned Herb added successfully",
                    });
                    props.getListOfAssignedHerbsList()
                    form.resetFields()
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    };

    return (
        <div className="AddHerb">
            <Row gutter={[16, { xs: 8, sm: 16, md: 24, lg: 16 }]} className="mt-3">

                <Col xs={24} sm={24} md={16} xl={11} xxl={8} className="text-center">

                    <Radio.Group defaultValue="all_herbs"
                        className="radio_btn_list mt-2"
                        onChange={(e) => setHerbsCategory(e.target.value)}>
                        {nutritionistType == 'Nutritionist (Ayurveda)' &&
                            <Radio value="recommended_herbs"> Recommended Herbs</Radio>
                        }
                        <Radio value="all_herbs">All Herbs</Radio>
                    </Radio.Group>
                </Col>
                <Col xs={24} sm={24} md={16} lg={16} xl={11} xxl={16}>
                    <Select
                        showSearch
                        placeholder={placeholderData}
                        className="w-100"
                        filterOption={(inputValue, option) =>
                            option.children.toLowerCase().includes(inputValue.toLowerCase())
                        }
                        defaultValue=''
                        value={herb}
                        onChange={(e) => setHerb(e)}
                    >
                        <Option value="" disabled hidden>
                            Select Herb
                        </Option>
                        {/* {
                            herbsDisplayOptionsList !== undefined && herbsDisplayOptionsList.length > 0 &&
                                // her option list for Allopathic Doctor
                                nutritionistType == 'Allopathic Doctor' ?
                                herbsDisplayOptionsList.map(option => (
                                    // 'Kitchen Herb' & 'Allopathic Medicine are visible to Allopathic Doctor 
                                    (option.typeOfHerb == 'Kitchen Herb' || option.typeOfHerb == 'Allopathic Medicine') &&
                                    <Option key={option.id} value={option.id}>{option.herb}</Option>
                                ))
                                :
                                // her option list for other nutritionist types
                                herbsDisplayOptionsList.map(option => (
                                    <Option key={option.id} value={option.id}>{option.herb}</Option>
                                ))
                        } */}
                        {/* {
                            herbsDisplayOptionsList !== undefined && herbsDisplayOptionsList.length > 0 &&
                                nutritionistType == 'Allopathic Doctor' ?
                                herbsDisplayOptionsList.map(option => (
                                    // 'Kitchen Herb' & 'Allopathic Medicine are visible to Allopathic Doctor 
                                    (option.typeOfHerb == 'Kitchen Herb' || option.typeOfHerb == 'Allopathic Medicine') &&
                                    <Option key={option.id} value={option.id}>{option.herb}</Option>
                                ))
                                :
                                // her option list for other nutritionist types
                                herbsDisplayOptionsList.map(option => (
                                    <Option key={option.id} value={option.id}>{option.herb}</Option>
                                ))
                        } */}


                        {/*  ayurvedic doctor has kitchen herbs and syurvedic  option medicine list  */}
                        {/* {
                            herbsDisplayOptionsList !== undefined && herbsDisplayOptionsList.length > 0 &&
                            nutritionistType == 'Nutritionist(Ayurveda)' &&
                            herbsDisplayOptionsList.map(option => (
                                // 'Kitchen Herb' & 'Allopathic Medicine are visible to Allopathic Doctor 
                                (option.typeOfHerb == 'Kitchen Herb' || option.typeOfHerb == 'Ayurveda Medicine') &&
                                <Option key={option.id} value={option.id}>{option.herb}</Option>
                            ))

                        } */}

                        {/* final code  */}

                        {
                            herbsDisplayOptionsList &&
                            herbsDisplayOptionsList.length > 0 &&
                            herbsDisplayOptionsList
                                .filter(option => {
                                    // if (nutritionistType == 'Allopathic Doctor') {
                                    //     // console.log("allopathic doctor");
                                    //     return option.typeOfHerb === 'Kitchen Herb' || option.typeOfHerb === 'Allopathic Medicine';
                                    // } else 
                                    if (nutritionistType == 'Nutritionist (Ayurveda)') {
                                        // console.log("ayurvedic doctor");
                                        return option.typeOfHerb === 'Kitchen Herb' || option.typeOfHerb === 'Ayurveda Medicine';
                                    } else {
                                        // console.log("all doctor", nutritionistType);
                                        return true; // For other nutritionist types
                                    }
                                })
                                .map(option => (
                                    <Option key={option.id} value={option.id}>{option.herb}</Option>
                                ))
                        }

                    </Select>
                </Col>
            </Row>

            <Form
                name="AddHerbForm"
                className="AddHerbForm"
                form={form}
                onFinish={onFinish}
            >
                <Row gutter={[16, { xs: 8, sm: 16, md: 24, lg: 2 }]} className="align-self-center">
                    <Col xs={24} sm={12} md={12} lg={12} xl={11} xxl={8}>
                        <label className="form-input-label">
                            Herb Name
                            {/* <span className="asterik"> *</span> */}
                        </label>
                        <Form.Item name="herb_name">
                            <Input disabled className="mt-2 p-2" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={12} xl={11} xxl={8}>
                        <label className="form-input-label">
                            Quantity
                            {/* <span className="asterik"> *</span> */}
                        </label>
                        <Form.Item name="quantity"
                            rules={[
                                {
                                    pattern: PHONE_PATTERN,
                                    message: "Please Enter Valid Data!",
                                },
                                {
                                    required: true,
                                    message: "Please Enter Quantity!",
                                },
                            ]}
                        >
                            <Input placeholder="Enter Quantity" className="mt-2 p-2" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={12} xl={11} xxl={8}>
                        <label className="form-input-label">
                            Unit
                            {/* <span className="asterik"> *</span> */}
                        </label>
                        <Form.Item name="unit"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select Unit!",
                                },
                            ]}
                        >
                            <Select
                                showSearch
                                placeholder="Select Unit"
                                className="w-100 mt-2 p-1"
                                filterOption={(inputValue, option) =>
                                    option.children.toLowerCase().includes(inputValue.toLowerCase())
                                }
                            >
                                {ingredientUnitOptions && ingredientUnitOptions.length > 0 && ingredientUnitOptions.map(option => (
                                    <Option key={option.id} value={option.id}>{option.name}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={12} xl={11} xxl={8}>
                        <label className="form-input-label">
                            Remark
                            {/* <span className="asterik"> *</span> */}
                        </label>
                        <Form.Item name="remark"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Enter Remark!",
                                },
                            ]}
                        >
                            <Input.TextArea placeholder="Remark" className="mt-2 p-2" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={12} xl={11} xxl={8}>
                        <label className="form-input-label">
                            Mealtime
                            {/* <span className="asterik"> *</span> */}
                        </label>
                        <Form.Item name="mealtime"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select Mealtime!",
                                },
                            ]}
                        >
                            <Select
                                showSearch
                                placeholder="Select Mealtime"
                                className="w-100 mt-2 p-1"
                                filterOption={(inputValue, option) =>
                                    option.children.toLowerCase().includes(inputValue.toLowerCase())
                                }
                            >
                                {mealTimeOptions && mealTimeOptions.length > 0 && mealTimeOptions.map(option => (
                                    <Option key={option.id} value={option.id}>{option.name}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={12} xl={11} xxl={8} className="align-self-center">
                        <Button htmlType="submit" className="submit-button border-0 rounded " >
                            Save Herb
                        </Button>
                    </Col>
                </Row>
            </Form>
        </div>
    )
}